// extracted by mini-css-extract-plugin
export default {"container":"success-response_container","wrapper":"success-response_wrapper","fadeIn":"success-response_fadeIn"};